import { useState, useRef, useEffect } from "react";
import { supabase } from "../supabaseClient";

// ── Palette YOMA ──────────────────────────────────────────────────────────────
const GOLD   = "#C9A96E";
const INK    = "#1C1915";
const WARM   = "#F8F4EE";
const BORDER = "#E7E1D8";
const MUTED  = "#8B7361";
const WHITE  = "#FFFFFF";
const SOFT   = "#F2EDE6";

const TVA_RATE = 0.20;

// ── Base de prix CYPE Maroc 2024-2025 (référentiel local) ─────────────────────
const PRICE_DB = [
  // ── Terrassements
  { chapitre:"Terrassements", designation:"Déblai en terrain ordinaire mécanisé", unite:"m³", pu:55 },
  { chapitre:"Terrassements", designation:"Remblai compacté en terrain d'apport", unite:"m³", pu:70 },
  { chapitre:"Terrassements", designation:"Fouilles en tranchée (fondations)", unite:"m³", pu:95 },
  { chapitre:"Terrassements", designation:"Nivellement et décapage de terrain", unite:"m²", pu:22 },
  { chapitre:"Terrassements", designation:"Évacuation des déblais en décharge", unite:"m³", pu:80 },
  { chapitre:"Terrassements", designation:"Remblai sous dallage granulat 0/31.5", unite:"m³", pu:115 },
  // ── Fondations
  { chapitre:"Fondations", designation:"Béton de propreté B15 dosé à 150 kg/m³", unite:"m³", pu:720 },
  { chapitre:"Fondations", designation:"Béton armé semelles filantes B25 — armé", unite:"m³", pu:1750 },
  { chapitre:"Fondations", designation:"Béton armé semelles isolées B25 — armé", unite:"m³", pu:1900 },
  { chapitre:"Fondations", designation:"Béton armé longrines de fondation B25", unite:"m³", pu:1850 },
  { chapitre:"Fondations", designation:"Ferraillage acier HA (armatures fondations)", unite:"kg", pu:13 },
  { chapitre:"Fondations", designation:"Coffrage bois fondations (perd)", unite:"m²", pu:110 },
  { chapitre:"Fondations", designation:"Hérisson en pierres sèches ep. 20cm", unite:"m²", pu:65 },
  // ── Gros Œuvre
  { chapitre:"Gros Œuvre", designation:"Béton armé poteaux B25 (coffrage métallique)", unite:"m³", pu:2400 },
  { chapitre:"Gros Œuvre", designation:"Béton armé poutres et chaînages B25", unite:"m³", pu:2250 },
  { chapitre:"Gros Œuvre", designation:"Béton armé dalle pleine B25 ep. 15cm", unite:"m³", pu:2100 },
  { chapitre:"Gros Œuvre", designation:"Béton armé voiles et refends B25", unite:"m³", pu:2200 },
  { chapitre:"Gros Œuvre", designation:"Béton armé escalier coulé en place B25", unite:"m³", pu:2800 },
  { chapitre:"Gros Œuvre", designation:"Maçonnerie parpaings creux 20 cm (murs ext.)", unite:"m²", pu:145 },
  { chapitre:"Gros Œuvre", designation:"Maçonnerie parpaings creux 15 cm (cloisons)", unite:"m²", pu:115 },
  { chapitre:"Gros Œuvre", designation:"Maçonnerie briques creuses 10 cm", unite:"m²", pu:95 },
  { chapitre:"Gros Œuvre", designation:"Plancher hourdis (corps creux 20+5)", unite:"m²", pu:310 },
  { chapitre:"Gros Œuvre", designation:"Plancher hourdis (corps creux 16+4)", unite:"m²", pu:280 },
  { chapitre:"Gros Œuvre", designation:"Ferraillage courant acier HA", unite:"kg", pu:13 },
  { chapitre:"Gros Œuvre", designation:"Coffrage métallique récupérable murs", unite:"m²", pu:95 },
  { chapitre:"Gros Œuvre", designation:"Dallage béton armé ep. 12cm (RDC)", unite:"m²", pu:185 },
  { chapitre:"Gros Œuvre", designation:"Arase étanche sous murs (hydrofuge)", unite:"ml", pu:35 },
  // ── Étanchéité
  { chapitre:"Étanchéité", designation:"Étanchéité multicouche bicouche SBS sur terrasse", unite:"m²", pu:230 },
  { chapitre:"Étanchéité", designation:"Étanchéité monocouche APP autoprotégée", unite:"m²", pu:155 },
  { chapitre:"Étanchéité", designation:"Protection étanchéité gravillons roulés 3/8", unite:"m²", pu:55 },
  { chapitre:"Étanchéité", designation:"Isolation thermique polystyrène extrudé 4cm", unite:"m²", pu:95 },
  { chapitre:"Étanchéité", designation:"Isolation thermique polyuréthane projeté 5cm", unite:"m²", pu:145 },
  { chapitre:"Étanchéité", designation:"Relevé d'étanchéité sur acrotère (ml)", unite:"ml", pu:85 },
  { chapitre:"Étanchéité", designation:"Étanchéité cuvelage sous-sol (3 couches)", unite:"m²", pu:310 },
  // ── Charpente & Couverture
  { chapitre:"Charpente & Couverture", designation:"Charpente bois sapin traité (fermettes)", unite:"m²", pu:275 },
  { chapitre:"Charpente & Couverture", designation:"Couverture tuiles béton sur volige", unite:"m²", pu:175 },
  { chapitre:"Charpente & Couverture", designation:"Couverture tôle bac acier laqué ep. 0.63mm", unite:"m²", pu:220 },
  { chapitre:"Charpente & Couverture", designation:"Gouttière aluminium développée 25cm", unite:"ml", pu:140 },
  { chapitre:"Charpente & Couverture", designation:"Descente EP aluminium Ø80mm", unite:"ml", pu:90 },
  { chapitre:"Charpente & Couverture", designation:"Acrotère béton armé (terrasse inaccessible)", unite:"ml", pu:320 },
  // ── Menuiseries
  { chapitre:"Menuiseries", designation:"Porte d'entrée aluminium 1 vantail laqué", unite:"U", pu:4500 },
  { chapitre:"Menuiseries", designation:"Porte extérieure aluminium double vantail", unite:"U", pu:7500 },
  { chapitre:"Menuiseries", designation:"Fenêtre aluminium 1 vantail oscillo-battant 80x120", unite:"U", pu:1900 },
  { chapitre:"Menuiseries", designation:"Fenêtre aluminium 2 vantaux oscillo-battants 120x120", unite:"U", pu:2800 },
  { chapitre:"Menuiseries", designation:"Baie vitrée coulissante aluminium 200x220", unite:"U", pu:5500 },
  { chapitre:"Menuiseries", designation:"Porte intérieure bois isoplane + bâti", unite:"U", pu:1500 },
  { chapitre:"Menuiseries", designation:"Porte intérieure bois plaquée chêne + bâti", unite:"U", pu:2800 },
  { chapitre:"Menuiseries", designation:"Volet roulant aluminium motorisé", unite:"U", pu:1800 },
  { chapitre:"Menuiseries", designation:"Portail coulissant aluminium motorisé 4m", unite:"U", pu:12000 },
  { chapitre:"Menuiseries", designation:"Garde-corps aluminium laqué ep. 10 cm", unite:"ml", pu:1100 },
  { chapitre:"Menuiseries", designation:"Garde-corps verre feuilleté 10mm + inox", unite:"ml", pu:2200 },
  { chapitre:"Menuiseries", designation:"Clôture aluminium sur muret (jardin)", unite:"ml", pu:950 },
  { chapitre:"Menuiseries", designation:"Brise-soleil orientable aluminium laqué", unite:"m²", pu:1800 },
  // ── Électricité
  { chapitre:"Électricité", designation:"Tableau électrique général 3x400V (jusqu'à 12 circuits)", unite:"U", pu:4500 },
  { chapitre:"Électricité", designation:"Tableau électrique divisionnaire (secondaire)", unite:"U", pu:2200 },
  { chapitre:"Électricité", designation:"Point d'éclairage (encastré ou saillie)", unite:"U", pu:320 },
  { chapitre:"Électricité", designation:"Prise de courant 16A avec terre (pose)", unite:"U", pu:240 },
  { chapitre:"Électricité", designation:"Interrupteur ou va-et-vient (pose)", unite:"U", pu:160 },
  { chapitre:"Électricité", designation:"Câblage réseau électrique (fourni+posé)", unite:"m²", pu:230 },
  { chapitre:"Électricité", designation:"Mise à la terre (piquet + liaison)", unite:"ens", pu:1800 },
  { chapitre:"Électricité", designation:"Alimentation VMC simple flux", unite:"U", pu:2500 },
  { chapitre:"Électricité", designation:"Chauffe-eau électrique 100L (fourni+posé)", unite:"U", pu:2200 },
  { chapitre:"Électricité", designation:"Climatiseur split 12000 BTU (fourni+posé)", unite:"U", pu:7500 },
  { chapitre:"Électricité", designation:"Éclairage extérieur façade (applique IP54)", unite:"U", pu:480 },
  { chapitre:"Électricité", designation:"Sonnette + visiophone couleur", unite:"U", pu:2500 },
  // ── Plomberie & Sanitaire
  { chapitre:"Plomberie & Sanitaire", designation:"Réseau alimentation eau PPR PN20 (fourni+posé)", unite:"ml", pu:60 },
  { chapitre:"Plomberie & Sanitaire", designation:"Réseau évacuation eaux usées PVC Ø100 (fourni+posé)", unite:"ml", pu:65 },
  { chapitre:"Plomberie & Sanitaire", designation:"Siphon de sol inox Ø50 (fourni+posé)", unite:"U", pu:280 },
  { chapitre:"Plomberie & Sanitaire", designation:"Lavabo suspendu + robinetterie mitigeur", unite:"U", pu:1600 },
  { chapitre:"Plomberie & Sanitaire", designation:"WC suspendu + abattant + bâti-support", unite:"U", pu:3500 },
  { chapitre:"Plomberie & Sanitaire", designation:"WC à poser standard (fourni+posé)", unite:"U", pu:1800 },
  { chapitre:"Plomberie & Sanitaire", designation:"Douche à l'italienne receveur + paroi verre", unite:"U", pu:5500 },
  { chapitre:"Plomberie & Sanitaire", designation:"Baignoire acrylique encastrée 170x70", unite:"U", pu:4200 },
  { chapitre:"Plomberie & Sanitaire", designation:"Évier cuisine inox 1 bac + robinetterie", unite:"U", pu:1900 },
  { chapitre:"Plomberie & Sanitaire", designation:"Chauffe-eau solaire thermosiphon 200L", unite:"U", pu:8500 },
  { chapitre:"Plomberie & Sanitaire", designation:"Compteur eau + disconnecteur (raccordement)", unite:"U", pu:2200 },
  { chapitre:"Plomberie & Sanitaire", designation:"Fosse septique béton 3m³ (fourni+posé)", unite:"U", pu:9500 },
  // ── Enduits & Revêtements
  { chapitre:"Enduits & Revêtements", designation:"Enduit de façade gratté fin (ciment+chaux)", unite:"m²", pu:115 },
  { chapitre:"Enduits & Revêtements", designation:"Enduit de façade tyrolien taloché", unite:"m²", pu:95 },
  { chapitre:"Enduits & Revêtements", designation:"Enduit intérieur plâtre lissé 2 couches", unite:"m²", pu:65 },
  { chapitre:"Enduits & Revêtements", designation:"Doublage intérieur plaque de plâtre BA13 + ossature", unite:"m²", pu:165 },
  { chapitre:"Enduits & Revêtements", designation:"Cloison distribution plâtre BA10 double parement", unite:"m²", pu:185 },
  { chapitre:"Enduits & Revêtements", designation:"Faux-plafond plaque de plâtre BA13 suspendu", unite:"m²", pu:145 },
  { chapitre:"Enduits & Revêtements", designation:"Ragréage sol autolissant (avant carrelage)", unite:"m²", pu:48 },
  { chapitre:"Enduits & Revêtements", designation:"Isolation thermique laine de verre 10cm combles", unite:"m²", pu:85 },
  // ── Carrelage & Sol
  { chapitre:"Carrelage & Sol", designation:"Carrelage grès cérame poli 60×60 (pose incluse)", unite:"m²", pu:230 },
  { chapitre:"Carrelage & Sol", designation:"Carrelage grès cérame rectifié 80×80 (pose incluse)", unite:"m²", pu:310 },
  { chapitre:"Carrelage & Sol", designation:"Carrelage grès cérame grand format 120×60", unite:"m²", pu:420 },
  { chapitre:"Carrelage & Sol", designation:"Faïence murale salle de bain 30×60 (pose incluse)", unite:"m²", pu:200 },
  { chapitre:"Carrelage & Sol", designation:"Faïence murale cuisine 20×50 (pose incluse)", unite:"m²", pu:175 },
  { chapitre:"Carrelage & Sol", designation:"Parquet contrecollé chêne 14mm (fourni+posé)", unite:"m²", pu:520 },
  { chapitre:"Carrelage & Sol", designation:"Béton ciré décoratif 2 couches + vernis", unite:"m²", pu:380 },
  { chapitre:"Carrelage & Sol", designation:"Marbre local taillé (fourni+posé)", unite:"m²", pu:480 },
  { chapitre:"Carrelage & Sol", designation:"Plinthes assorties (pose carrelage)", unite:"ml", pu:55 },
  // ── Peinture
  { chapitre:"Peinture", designation:"Peinture acrylique intérieure 2 couches (murs+plafonds)", unite:"m²", pu:45 },
  { chapitre:"Peinture", designation:"Peinture façade siloxane 2 couches + primaire", unite:"m²", pu:62 },
  { chapitre:"Peinture", designation:"Peinture boiseries bois (lasure ou glycéro)", unite:"m²", pu:80 },
  { chapitre:"Peinture", designation:"Sous-couche primaire d'accrochage", unite:"m²", pu:18 },
  { chapitre:"Peinture", designation:"Peinture décorative tadelakt (douche)", unite:"m²", pu:320 },
  // ── VRD & Aménagements extérieurs
  { chapitre:"VRD & Aménagements extérieurs", designation:"Dallage extérieur béton désactivé ep. 12cm", unite:"m²", pu:220 },
  { chapitre:"VRD & Aménagements extérieurs", designation:"Dallage pierre naturelle (pose sur sable)", unite:"m²", pu:380 },
  { chapitre:"VRD & Aménagements extérieurs", designation:"Bordures de trottoir béton T2 (fourni+posé)", unite:"ml", pu:65 },
  { chapitre:"VRD & Aménagements extérieurs", designation:"Clôture parpaings creux 20cm ep. (H=2m)", unite:"ml", pu:480 },
  { chapitre:"VRD & Aménagements extérieurs", designation:"Enduit crépis clôture extérieure", unite:"m²", pu:90 },
  { chapitre:"VRD & Aménagements extérieurs", designation:"Réseau irrigation enterré PVC Ø25 (jardin)", unite:"ml", pu:45 },
  { chapitre:"VRD & Aménagements extérieurs", designation:"Borne lumineuse jardin IP65 (fourni+posé)", unite:"U", pu:950 },
  { chapitre:"VRD & Aménagements extérieurs", designation:"Piscine maçonnée coque polyester 8×4 (structure)", unite:"ens", pu:120000 },
  { chapitre:"VRD & Aménagements extérieurs", designation:"Terrasse bois composite (lames+structure alu)", unite:"m²", pu:680 },
  { chapitre:"VRD & Aménagements extérieurs", designation:"Gazon naturel (fourni+pose+arrosage 1an)", unite:"m²", pu:85 },
  { chapitre:"VRD & Aménagements extérieurs", designation:"Plantation arbre (olivier adulte + tuteur)", unite:"U", pu:2800 },
  { chapitre:"VRD & Aménagements extérieurs", designation:"Réseau EU+EP enterré Ø200 (raccordement)", unite:"ml", pu:180 },
];

// Recherche locale fuzzy dans PRICE_DB
function searchLocal(query) {
  if (!query.trim()) return [];
  const terms = query.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"").split(/\s+/).filter(t => t.length > 2);
  if (!terms.length) return [];
  return PRICE_DB
    .map(item => {
      const hay = (item.designation + " " + item.chapitre).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"");
      const score = terms.reduce((s, t) => s + (hay.includes(t) ? 1 : 0), 0);
      return { ...item, score };
    })
    .filter(i => i.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, 30);
}

const CHAPITRES = [
  "Terrassements",
  "Fondations",
  "Gros Œuvre",
  "Étanchéité",
  "Charpente & Couverture",
  "Menuiseries",
  "Électricité",
  "Plomberie & Sanitaire",
  "Enduits & Revêtements",
  "Carrelage & Sol",
  "Peinture",
  "VRD & Aménagements extérieurs",
  "Divers",
];

const UNITS = ["m²", "m³", "ml", "U", "kg", "t", "m", "ens", "ff", "h"];

const CHAPITRE_COLORS: Record<string, string> = {
  "Terrassements":            "#8B6E4E",
  "Fondations":               "#7A5C3A",
  "Gros Œuvre":               "#5C4A3A",
  "Étanchéité":               "#3A5C5A",
  "Charpente & Couverture":   "#4A5C3A",
  "Menuiseries":              "#2A4A6A",
  "Électricité":              "#6A4A2A",
  "Plomberie & Sanitaire":    "#2A5A7A",
  "Enduits & Revêtements":    "#5A3A6A",
  "Carrelage & Sol":          "#7A3A3A",
  "Peinture":                 "#3A7A5A",
  "VRD & Aménagements extérieurs": "#4A4A7A",
  "Divers":                   "#6A6A6A",
};

let _nextId = 1;
function mkId() { return `r${_nextId++}`; }

function newRow(partial = {}) {
  return {
    id: mkId(),
    chapitre: "Gros Œuvre",
    designation: "",
    quantite: 1,
    unite: "m²",
    puHt: 0,
    ...partial,
  };
}

function fmt(n, decimals = 2) {
  return Number(n || 0).toLocaleString("fr-MA", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

// ── Mini composants ────────────────────────────────────────────────────────────
function Label({ children, gold }) {
  return (
    <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: "0.14em", color: gold ? GOLD : "#7A6A60", marginBottom: 5, textTransform: "uppercase" }}>
      {children}
    </div>
  );
}

function SideBtn({ onClick, disabled, children, style = {} }) {
  return (
    <button onClick={onClick} disabled={disabled}
      style={{ border: "none", borderRadius: 8, padding: "10px 0", cursor: disabled ? "default" : "pointer",
        fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: 12, width: "100%",
        opacity: disabled ? 0.4 : 1, transition: "all .15s", ...style }}>
      {children}
    </button>
  );
}

function ModeTab({ active, onClick, children }) {
  return (
    <button onClick={onClick}
      style={{ flex: 1, border: "none", borderBottom: active ? `2px solid ${GOLD}` : "2px solid transparent",
        background: "none", padding: "8px 4px", fontSize: 12, fontWeight: active ? 700 : 400,
        color: active ? INK : MUTED, cursor: "pointer", fontFamily: "'DM Sans',sans-serif",
        transition: "all .15s", whiteSpace: "nowrap" }}>
      {children}
    </button>
  );
}

// ── Page principale ───────────────────────────────────────────────────────────
export default function DevisIntelligentPage({ cabinetId }) {
  // Infos devis
  const [projName,      setProjName]      = useState("");
  const [clientName,    setClientName]    = useState("");
  const [clientAdresse, setClientAdresse] = useState("");
  const [devisNum,      setDevisNum]      = useState(() => `DEV-${new Date().getFullYear()}-001`);
  const [devisDate,     setDevisDate]     = useState(() => new Date().toISOString().slice(0, 10));
  const [logoUrl,       setLogoUrl]       = useState(null);

  // Lignes du devis
  const [rows, setRows] = useState([newRow()]);

  // Mode de saisie
  const [mode, setMode] = useState("cype"); // "cype" | "ia" | "manuel"

  // Recherche CYPE
  const [searchQ,       setSearchQ]       = useState("");
  const [searching,     setSearching]     = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searchError,   setSearchError]   = useState("");
  const [searchSource,  setSearchSource]  = useState("");

  // Dictée IA
  const [iaPrompt,  setIaPrompt]  = useState("");
  const [iaLoading, setIaLoading] = useState(false);

  // Gemini key (shared with other modules)
  const [geminiKey, setGeminiKey] = useState(() => localStorage.getItem("yoma_gemini_key") || "");
  const [showKey,   setShowKey]   = useState(false);

  const [error, setError] = useState("");

  const logoRef = useRef();

  useEffect(() => { if (geminiKey) localStorage.setItem("yoma_gemini_key", geminiKey); }, [geminiKey]);

  // ── Totaux ────────────────────────────────────────────────────────────────
  const totalHt  = rows.reduce((s, r) => s + (Number(r.quantite) || 0) * (Number(r.puHt) || 0), 0);
  const tvaAmt   = totalHt * TVA_RATE;
  const totalTtc = totalHt + tvaAmt;

  // ── Opérations sur les lignes ─────────────────────────────────────────────
  function addRow(partial = {}) {
    setRows(prev => [...prev, newRow(partial)]);
  }

  function updRow(id, field, value) {
    setRows(prev => prev.map(r => r.id === id ? { ...r, [field]: value } : r));
  }

  function delRow(id) {
    setRows(prev => prev.filter(r => r.id !== id));
  }

  function moveRow(id, dir) {
    setRows(prev => {
      const idx = prev.findIndex(r => r.id === id);
      const next = [...prev];
      const swap = dir === "up" ? idx - 1 : idx + 1;
      if (swap < 0 || swap >= next.length) return prev;
      [next[idx], next[swap]] = [next[swap], next[idx]];
      return next;
    });
  }

  // ── Logo upload ───────────────────────────────────────────────────────────
  function handleLogo(e) {
    const f = e.target.files[0];
    if (!f) return;
    const reader = new FileReader();
    reader.onload = ev => setLogoUrl(ev.target.result);
    reader.readAsDataURL(f);
  }

  // ── Recherche CYPE (Edge Function + fallback local) ───────────────────────
  async function searchCype() {
    if (!searchQ.trim()) return;
    setSearching(true);
    setSearchError("");
    setSearchResults([]);
    setSearchSource("");

    // 1. Essayer l'Edge Function Supabase (CYPE live)
    let liveItems = [];
    try {
      const { data, error: fnErr } = await supabase.functions.invoke("cype-proxy", {
        body: { query: searchQ.trim() },
      });
      if (!fnErr && !data?.error && data?.items?.length) {
        liveItems = data.items;
        setSearchSource("maroc.prix-construction.info (live)");
      }
    } catch (_) {
      // Edge Function non disponible — on continuera avec la DB locale
    }

    // 2. Recherche dans la base locale CYPE Maroc
    const localItems = searchLocal(searchQ);

    // 3. Fusionner : live en tête, puis local (dédupliqués par désignation)
    const liveDesigs = new Set(liveItems.map(i => i.designation.toLowerCase()));
    const merged = [
      ...liveItems,
      ...localItems.filter(i => !liveDesigs.has(i.designation.toLowerCase())),
    ];

    if (merged.length) {
      setSearchResults(merged);
      if (!liveItems.length) setSearchSource("Base CYPE Maroc locale 2024-2025");
    } else {
      setSearchError("Aucun résultat. Essayez : béton, parpaing, enduit, carrelage, fenêtre…");
    }

    setSearching(false);
  }

  function addFromCype(item) {
    // Mapper chapitre CYPE → libellé YOMA
    const ch = guessChapitre(item.chapitre || item.designation);
    addRow({
      chapitre:    ch,
      designation: item.designation,
      unite:       normalizeUnit(item.unite),
      puHt:        item.pu,
      quantite:    1,
    });
  }

  function guessChapitre(text = "") {
    const t = text.toLowerCase();
    if (t.includes("fondation") || t.includes("semelle"))         return "Fondations";
    if (t.includes("terrassement") || t.includes("excavation"))   return "Terrassements";
    if (t.includes("étanchéité") || t.includes("etancheite"))     return "Étanchéité";
    if (t.includes("charpente") || t.includes("couverture") || t.includes("toiture")) return "Charpente & Couverture";
    if (t.includes("menuiserie") || t.includes("porte") || t.includes("fenêtre")) return "Menuiseries";
    if (t.includes("électricité") || t.includes("electricite") || t.includes("tableau")) return "Électricité";
    if (t.includes("plomberie") || t.includes("sanitaire") || t.includes("eau")) return "Plomberie & Sanitaire";
    if (t.includes("enduit") || t.includes("crépissage") || t.includes("ravalement")) return "Enduits & Revêtements";
    if (t.includes("carrelage") || t.includes("sol") || t.includes("parquet")) return "Carrelage & Sol";
    if (t.includes("peinture") || t.includes("lasure"))          return "Peinture";
    if (t.includes("vrd") || t.includes("voirie") || t.includes("réseau")) return "VRD & Aménagements extérieurs";
    return "Gros Œuvre";
  }

  function normalizeUnit(u = "") {
    const map = { m2: "m²", m3: "m³", ml: "ml", u: "U", ens: "ens", ff: "ff" };
    return map[u.toLowerCase()] || u || "U";
  }

  // ── Dictée IA via Gemini ──────────────────────────────────────────────────
  async function interpretIa() {
    if (!iaPrompt.trim()) return;
    if (!geminiKey.trim()) { setError("⚠ Clé API Gemini requise pour la Dictée IA."); return; }
    setIaLoading(true);
    setError("");
    try {
      const systemPrompt =
`Tu es un expert en chiffrage BTP au Maroc (référentiel CYPE Maroc 2024-2025).
L'utilisateur décrit des travaux de construction en français naturel.
Génère un devis détaillé sous forme de tableau JSON.
Réponds UNIQUEMENT avec un tableau JSON valide — sans markdown, sans explication.

Format exact :
[
  {"chapitre":"Gros Œuvre","designation":"Béton armé pour semelles filantes dosé à 350 kg/m³","quantite":45,"unite":"m³","puHt":1850},
  ...
]

Chapitres valides : Terrassements, Fondations, Gros Œuvre, Étanchéité, Charpente & Couverture, Menuiseries, Électricité, Plomberie & Sanitaire, Enduits & Revêtements, Carrelage & Sol, Peinture, VRD & Aménagements extérieurs, Divers
Unités valides : m², m³, ml, U, kg, t, m, ens, ff, h
Prix unitaires HT en dirhams marocains (DH HT) — basés sur les prix du marché marocain.
Sois précis sur les désignations techniques (classe béton, dosage, épaisseur, référence norme marocaine si pertinent).
Décompose au maximum : un poste par type d'ouvrage.`;

      const res = await fetch(
        `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=${geminiKey}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            contents: [{ parts: [{ text: `${systemPrompt}\n\nTravaux à chiffrer :\n${iaPrompt}` }] }],
            generationConfig: { temperature: 0.15, maxOutputTokens: 4096 },
          }),
          signal: AbortSignal.timeout(40_000),
        }
      );
      if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error(e.error?.message || `HTTP ${res.status}`); }
      const data = await res.json();
      const text = data.candidates?.[0]?.content?.parts?.[0]?.text || "";
      const jsonMatch = text.match(/\[[\s\S]*\]/);
      if (!jsonMatch) throw new Error("Réponse IA invalide — aucun JSON trouvé. Réessayez.");
      const items = JSON.parse(jsonMatch[0]);
      if (!Array.isArray(items) || !items.length) throw new Error("Liste de postes vide.");
      items.forEach(it => addRow({
        chapitre:    CHAPITRES.includes(it.chapitre) ? it.chapitre : "Gros Œuvre",
        designation: it.designation || "",
        quantite:    Number(it.quantite) || 1,
        unite:       normalizeUnit(it.unite),
        puHt:        Number(it.puHt) || 0,
      }));
      setIaPrompt("");
    } catch (e) {
      setError(`❌ Dictée IA : ${e.message}`);
    } finally {
      setIaLoading(false);
    }
  }

  // ── Export PDF (impression navigateur) ────────────────────────────────────
  function exportPdf() { window.print(); }

  // ── Groupement par chapitre ───────────────────────────────────────────────
  const grouped = {};
  rows.forEach(r => {
    if (!grouped[r.chapitre]) grouped[r.chapitre] = [];
    grouped[r.chapitre].push(r);
  });

  const chapitresInUse = CHAPITRES.filter(ch => grouped[ch]?.length);

  // ═══════════════════════════════════════════════════════════════════════════
  return (
    <div style={{ display: "flex", minHeight: "100vh", background: WARM, fontFamily: "'DM Sans',sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=DM+Sans:wght@300;400;500;600&display=swap');
        .dv-inp{background:${WHITE};border:1px solid ${BORDER};border-radius:6px;padding:7px 10px;font-size:12px;color:${INK};width:100%;box-sizing:border-box;font-family:'DM Sans',sans-serif;outline:none;}
        .dv-inp:focus{border-color:${GOLD};}
        .dv-inp-dark{background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.12);border-radius:6px;padding:7px 10px;font-size:12px;color:${WHITE};width:100%;box-sizing:border-box;font-family:'DM Sans',sans-serif;outline:none;}
        .dv-inp-dark:focus{border-color:${GOLD};}
        .dv-btn{border:none;border-radius:8px;padding:9px 18px;cursor:pointer;font-size:12px;font-weight:700;transition:all .15s;font-family:'DM Sans',sans-serif;}
        .dv-btn:hover:not(:disabled){opacity:.85;transform:translateY(-1px);}
        .dv-btn:disabled{opacity:.4;cursor:default;}
        .res-card{background:${WHITE};border:1px solid ${BORDER};border-radius:10px;padding:10px 14px;cursor:pointer;transition:all .2s;display:flex;justify-content:space-between;align-items:center;gap:12px;margin-bottom:8px;}
        .res-card:hover{border-color:${GOLD};background:${SOFT};}
        .tbl-inp{border:none;background:transparent;font-size:12px;color:${INK};width:100%;font-family:'DM Sans',sans-serif;outline:none;padding:2px 4px;}
        .tbl-inp:focus{background:${SOFT};border-radius:4px;}
        @media print{
          .no-print{display:none!important;}
          body{background:white!important;}
          .print-area{display:block!important;}
          .dv-sidebar,.dv-modes,.dv-actions{display:none!important;}
        }
        .print-area{display:none;}
      `}</style>

      {/* ═══════ SIDEBAR ═══════ */}
      <aside className="dv-sidebar no-print"
        style={{ width: 250, background: INK, display: "flex", flexDirection: "column", padding: "22px 14px", flexShrink: 0, overflowY: "auto" }}>

        {/* Logo YOMA */}
        <div style={{ textAlign: "center", marginBottom: 20, paddingBottom: 16, borderBottom: "1px solid rgba(255,255,255,.1)" }}>
          <div style={{ color: GOLD, fontFamily: "'Playfair Display',serif", fontSize: 18, fontWeight: 700, letterSpacing: 3 }}>YOMA</div>
          <div style={{ color: "#5A4E46", fontSize: 9, letterSpacing: "0.22em", marginTop: 2 }}>DEVIS INTELLIGENT</div>
        </div>

        {/* Logo société */}
        <div style={{ marginBottom: 14 }}>
          <Label>LOGO SOCIÉTÉ</Label>
          {logoUrl ? (
            <div style={{ position: "relative" }}>
              <img src={logoUrl} alt="Logo" style={{ width: "100%", maxHeight: 60, objectFit: "contain", borderRadius: 6, background: "rgba(255,255,255,.05)", padding: 6 }} />
              <button onClick={() => setLogoUrl(null)}
                style={{ position: "absolute", top: 2, right: 2, background: "rgba(0,0,0,.5)", border: "none", color: WHITE, borderRadius: "50%", width: 18, height: 18, fontSize: 10, cursor: "pointer", lineHeight: 1 }}>✕</button>
            </div>
          ) : (
            <div onClick={() => logoRef.current.click()}
              style={{ border: "1px dashed rgba(255,255,255,.2)", borderRadius: 6, padding: "10px", textAlign: "center", cursor: "pointer", color: "#6A5E55", fontSize: 11 }}>
              + Charger logo
            </div>
          )}
          <input ref={logoRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleLogo} />
        </div>

        {/* Infos devis */}
        <div style={{ marginBottom: 14 }}>
          <Label>N° DEVIS</Label>
          <input className="dv-inp-dark" value={devisNum} onChange={e => setDevisNum(e.target.value)} style={{ marginBottom: 6 }} />
          <Label>DATE</Label>
          <input type="date" className="dv-inp-dark" value={devisDate} onChange={e => setDevisDate(e.target.value)} />
        </div>

        {/* Infos projet */}
        <div style={{ marginBottom: 14, padding: "10px", background: "rgba(255,255,255,.04)", borderRadius: 8 }}>
          <Label>PROJET / CLIENT</Label>
          <input className="dv-inp-dark" placeholder="Nom du projet…" value={projName} onChange={e => setProjName(e.target.value)} autoComplete="off" style={{ marginBottom: 6 }} />
          <input className="dv-inp-dark" placeholder="Nom du client…" value={clientName} onChange={e => setClientName(e.target.value)} autoComplete="off" style={{ marginBottom: 6 }} />
          <input className="dv-inp-dark" placeholder="Adresse du projet…" value={clientAdresse} onChange={e => setClientAdresse(e.target.value)} autoComplete="off" />
        </div>

        {/* Clé Gemini */}
        <div style={{ marginBottom: 14, padding: "10px", background: "rgba(201,169,110,.08)", borderRadius: 8, border: "1px solid rgba(201,169,110,.15)" }}>
          <Label gold>CLÉ GEMINI (Dictée IA)</Label>
          <div style={{ display: "flex", gap: 4 }}>
            <input type={showKey ? "text" : "password"} className="dv-inp-dark" placeholder="AIza…" value={geminiKey} onChange={e => setGeminiKey(e.target.value)} style={{ fontSize: 10, fontFamily: "monospace" }} />
            <button onClick={() => setShowKey(v => !v)} style={{ background: "none", border: "none", color: MUTED, cursor: "pointer", fontSize: 13, padding: "0 2px" }}>{showKey ? "🙈" : "👁"}</button>
          </div>
        </div>

        {/* Totaux */}
        <div style={{ marginBottom: 14, padding: "12px", background: "rgba(255,255,255,.04)", borderRadius: 8 }}>
          <Label>RÉCAPITULATIF</Label>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
            <span style={{ color: "#9A8A80", fontSize: 11 }}>Total HT</span>
            <span style={{ color: WHITE, fontSize: 12, fontWeight: 600 }}>{fmt(totalHt)} MAD</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
            <span style={{ color: "#9A8A80", fontSize: 11 }}>TVA (20 %)</span>
            <span style={{ color: "#BBA990", fontSize: 11 }}>{fmt(tvaAmt)} MAD</span>
          </div>
          <div style={{ height: 1, background: "rgba(255,255,255,.08)", margin: "8px 0" }} />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ color: GOLD, fontSize: 12, fontWeight: 700 }}>TOTAL TTC</span>
            <span style={{ color: GOLD, fontSize: 14, fontWeight: 800 }}>{fmt(totalTtc)} MAD</span>
          </div>
          <div style={{ color: "#4A3E35", fontSize: 10, marginTop: 8 }}>{rows.length} poste{rows.length > 1 ? "s" : ""} · {chapitresInUse.length} lot{chapitresInUse.length > 1 ? "s" : ""}</div>
        </div>

        {/* Actions */}
        <div className="dv-actions" style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: "auto" }}>
          <SideBtn onClick={exportPdf} style={{ background: GOLD, color: INK }}>
            🖨 Exporter PDF
          </SideBtn>
          <SideBtn onClick={() => setRows([newRow()])}
            style={{ background: "rgba(255,255,255,.05)", color: "#9A8A80", border: "1px solid rgba(255,255,255,.1)" }}>
            ↺ Réinitialiser
          </SideBtn>
        </div>
      </aside>

      {/* ═══════ MAIN ═══════ */}
      <main style={{ flex: 1, padding: "28px 32px", overflow: "auto", maxWidth: "calc(100vw - 250px)" }}>

        {/* Header */}
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontFamily: "'Playfair Display',serif", fontSize: 26, fontWeight: 700, color: INK }}>
            Devis Intelligent
          </div>
          <div style={{ color: MUTED, fontSize: 13, marginTop: 4 }}>
            Recherche CYPE en temps réel · Dictée IA · Saisie manuelle — Export PDF professionnel
          </div>
        </div>

        {/* Error banner */}
        {error && (
          <div style={{ background: "#FFEBEE", border: "1px solid #FFCDD2", borderRadius: 8, padding: "10px 16px", marginBottom: 20,
            color: "#B85C3A", fontSize: 13, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <span style={{ whiteSpace: "pre-wrap", flex: 1 }}>{error}</span>
            <button onClick={() => setError("")} style={{ background: "none", border: "none", cursor: "pointer", color: "#B85C3A", fontSize: 18, lineHeight: 1, marginLeft: 8 }}>×</button>
          </div>
        )}

        {/* ── Modes de saisie ── */}
        <div className="dv-modes" style={{ background: WHITE, borderRadius: 16, border: `1px solid ${BORDER}`, marginBottom: 24, overflow: "hidden" }}>
          {/* Tabs */}
          <div style={{ display: "flex", borderBottom: `1px solid ${BORDER}`, padding: "0 20px" }}>
            <ModeTab active={mode === "cype"} onClick={() => setMode("cype")}>🔍 Recherche CYPE</ModeTab>
            <ModeTab active={mode === "ia"}   onClick={() => setMode("ia")}>🤖 Dictée IA</ModeTab>
            <ModeTab active={mode === "manuel"} onClick={() => setMode("manuel")}>✍️ Saisie manuelle</ModeTab>
          </div>

          <div style={{ padding: "20px 24px" }}>

            {/* ── Mode CYPE ── */}
            {mode === "cype" && (
              <div>
                <div style={{ fontSize: 12, color: MUTED, marginBottom: 12 }}>
                  Recherchez un ouvrage dans la base CYPE Maroc et cliquez sur le résultat pour l'ajouter au devis.
                </div>
                <div style={{ display: "flex", gap: 10, marginBottom: 16 }}>
                  <input className="dv-inp" placeholder="Ex : béton armé, parpaing 20cm, enduit de façade…"
                    value={searchQ} onChange={e => setSearchQ(e.target.value)}
                    onKeyDown={e => e.key === "Enter" && searchCype()}
                    style={{ flex: 1 }} />
                  <button className="dv-btn" onClick={searchCype} disabled={!searchQ.trim() || searching}
                    style={{ background: INK, color: WHITE, minWidth: 120 }}>
                    {searching ? "⏳ Recherche…" : "🔍 Rechercher"}
                  </button>
                </div>

                {searchError && (
                  <div style={{ background: "#FFF8E1", border: "1px solid #FFE082", borderRadius: 8, padding: "10px 14px",
                    color: "#7A5800", fontSize: 12, marginBottom: 12 }}>
                    {searchError}
                  </div>
                )}

                {searchSource && (
                  <div style={{ fontSize: 10, color: MUTED, marginBottom: 10 }}>
                    Source : {searchSource}
                  </div>
                )}

                {searchResults.length > 0 && (
                  <div style={{ maxHeight: 320, overflowY: "auto" }}>
                    {searchResults.map((item, i) => (
                      <div key={i} className="res-card" onClick={() => addFromCype(item)}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 12, fontWeight: 600, color: INK, marginBottom: 2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {item.code && <span style={{ color: MUTED, marginRight: 6, fontSize: 10 }}>{item.code}</span>}
                            {item.designation}
                          </div>
                          <div style={{ fontSize: 11, color: MUTED }}>{item.unite} · {fmt(item.pu)} DH HT</div>
                        </div>
                        <div style={{ background: GOLD, color: INK, borderRadius: 6, padding: "4px 10px", fontSize: 11, fontWeight: 700, flexShrink: 0 }}>
                          + Ajouter
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {!searching && !searchResults.length && !searchError && (
                  <div style={{ textAlign: "center", padding: "24px 0", color: MUTED, fontSize: 12 }}>
                    Entrez un terme de recherche et appuyez sur Entrée
                  </div>
                )}
              </div>
            )}

            {/* ── Mode IA ── */}
            {mode === "ia" && (
              <div>
                <div style={{ fontSize: 12, color: MUTED, marginBottom: 12 }}>
                  Décrivez les travaux en langage naturel — Gemini génère automatiquement les lignes de devis avec quantités et prix unitaires CYPE Maroc.
                </div>
                <textarea className="dv-inp" placeholder={`Exemple : Construction d'une villa de 200 m² sur 2 niveaux, avec fondations en béton armé, murs en parpaings 20 cm, dalle de compression, couverture en tuiles, enduit de façade, 12 fenêtres aluminium, 3 portes extérieures, électricité complète et plomberie sanitaire avec 3 salles de bain.`}
                  value={iaPrompt} onChange={e => setIaPrompt(e.target.value)}
                  style={{ minHeight: 120, resize: "vertical", lineHeight: 1.6, marginBottom: 12 }} />
                <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                  <button className="dv-btn" onClick={interpretIa} disabled={!iaPrompt.trim() || iaLoading || !geminiKey.trim()}
                    style={{ background: INK, color: WHITE }}>
                    {iaLoading ? "⏳ Génération en cours…" : "🤖 Générer le devis"}
                  </button>
                  {!geminiKey.trim() && (
                    <span style={{ fontSize: 11, color: "#B85C3A" }}>⚠ Clé Gemini requise (panneau gauche)</span>
                  )}
                </div>
              </div>
            )}

            {/* ── Mode Manuel ── */}
            {mode === "manuel" && (
              <div>
                <div style={{ fontSize: 12, color: MUTED, marginBottom: 12 }}>
                  Ajoutez des lignes manuellement. Sélectionnez le lot, renseignez la désignation, la quantité et le prix unitaire.
                </div>
                <button className="dv-btn" onClick={() => addRow()}
                  style={{ background: INK, color: WHITE }}>
                  + Ajouter une ligne
                </button>
              </div>
            )}
          </div>
        </div>

        {/* ── Tableau de devis ── */}
        <div style={{ background: WHITE, borderRadius: 16, border: `1px solid ${BORDER}`, overflow: "hidden", marginBottom: 24 }}>
          <div style={{ padding: "16px 24px", borderBottom: `1px solid ${BORDER}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ fontFamily: "'Playfair Display',serif", fontSize: 16, fontWeight: 700, color: INK }}>
              Détail du devis
            </div>
            <button className="dv-btn no-print" onClick={() => addRow()}
              style={{ background: SOFT, color: INK, border: `1px solid ${BORDER}`, fontSize: 11 }}>
              + Ajouter une ligne
            </button>
          </div>

          {/* En-tête table */}
          <div style={{ display: "grid", gridTemplateColumns: "180px 1fr 80px 70px 110px 110px 60px",
            padding: "8px 12px", background: SOFT, borderBottom: `1px solid ${BORDER}`,
            fontSize: 10, fontWeight: 800, color: MUTED, letterSpacing: "0.08em", textTransform: "uppercase" }}>
            <div>Lot / Chapitre</div>
            <div>Désignation</div>
            <div style={{ textAlign: "center" }}>Qté</div>
            <div style={{ textAlign: "center" }}>Unité</div>
            <div style={{ textAlign: "right" }}>PU HT (MAD)</div>
            <div style={{ textAlign: "right" }}>Total HT (MAD)</div>
            <div />
          </div>

          {/* Corps */}
          {rows.length === 0 ? (
            <div style={{ textAlign: "center", padding: "40px 0", color: MUTED, fontSize: 13 }}>
              Aucune ligne — utilisez la recherche CYPE, la Dictée IA ou ajoutez manuellement.
            </div>
          ) : (
            <>
              {chapitresInUse.map(ch => (
                <div key={ch}>
                  {/* En-tête de lot */}
                  <div style={{ display: "grid", gridTemplateColumns: "180px 1fr 80px 70px 110px 110px 60px",
                    padding: "7px 12px", background: `${CHAPITRE_COLORS[ch] || "#4A3E35"}18`,
                    borderBottom: `1px solid ${BORDER}` }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: CHAPITRE_COLORS[ch] || INK, gridColumn: "1 / 6" }}>
                      ▸ {ch}
                    </div>
                    <div style={{ textAlign: "right", fontSize: 11, fontWeight: 700, color: INK }}>
                      {fmt(grouped[ch].reduce((s, r) => s + (Number(r.quantite)||0)*(Number(r.puHt)||0), 0))}
                    </div>
                    <div />
                  </div>

                  {/* Lignes */}
                  {grouped[ch].map((row, ri) => (
                    <div key={row.id}
                      style={{ display: "grid", gridTemplateColumns: "180px 1fr 80px 70px 110px 110px 60px",
                        padding: "6px 12px", borderBottom: `1px solid ${BORDER}`,
                        background: ri % 2 === 0 ? WHITE : "#FDFBF8", alignItems: "center" }}>

                      {/* Lot selector */}
                      <select value={row.chapitre} onChange={e => updRow(row.id, "chapitre", e.target.value)}
                        className="no-print"
                        style={{ fontSize: 11, border: "none", background: "transparent", color: MUTED, cursor: "pointer", width: "100%", fontFamily: "'DM Sans',sans-serif" }}>
                        {CHAPITRES.map(c => <option key={c} value={c}>{c}</option>)}
                      </select>

                      {/* Désignation */}
                      <input className="tbl-inp" value={row.designation}
                        onChange={e => updRow(row.id, "designation", e.target.value)}
                        placeholder="Désignation de l'ouvrage…" />

                      {/* Qté */}
                      <input type="number" className="tbl-inp" value={row.quantite} min="0" step="0.01"
                        onChange={e => updRow(row.id, "quantite", e.target.value)}
                        style={{ textAlign: "center" }} />

                      {/* Unité */}
                      <select value={row.unite} onChange={e => updRow(row.id, "unite", e.target.value)}
                        style={{ fontSize: 11, border: "none", background: "transparent", color: INK, cursor: "pointer", textAlign: "center", fontFamily: "'DM Sans',sans-serif", width: "100%" }}>
                        {UNITS.map(u => <option key={u} value={u}>{u}</option>)}
                      </select>

                      {/* PU HT */}
                      <input type="number" className="tbl-inp" value={row.puHt} min="0" step="0.01"
                        onChange={e => updRow(row.id, "puHt", e.target.value)}
                        style={{ textAlign: "right" }} />

                      {/* Total HT */}
                      <div style={{ textAlign: "right", fontSize: 12, fontWeight: 600, color: INK }}>
                        {fmt((Number(row.quantite)||0) * (Number(row.puHt)||0))}
                      </div>

                      {/* Actions */}
                      <div className="no-print" style={{ display: "flex", gap: 2, justifyContent: "center" }}>
                        <button onClick={() => moveRow(row.id, "up")}
                          style={{ background: "none", border: "none", cursor: "pointer", color: MUTED, fontSize: 12, padding: "2px 3px" }} title="Monter">↑</button>
                        <button onClick={() => moveRow(row.id, "down")}
                          style={{ background: "none", border: "none", cursor: "pointer", color: MUTED, fontSize: 12, padding: "2px 3px" }} title="Descendre">↓</button>
                        <button onClick={() => delRow(row.id)}
                          style={{ background: "none", border: "none", cursor: "pointer", color: "#C0392B", fontSize: 14, padding: "2px 3px" }} title="Supprimer">✕</button>
                      </div>
                    </div>
                  ))}
                </div>
              ))}

              {/* Lignes sans chapitre connu */}
              {rows.filter(r => !chapitresInUse.includes(r.chapitre)).map((row, ri) => (
                <div key={row.id}
                  style={{ display: "grid", gridTemplateColumns: "180px 1fr 80px 70px 110px 110px 60px",
                    padding: "6px 12px", borderBottom: `1px solid ${BORDER}`,
                    background: ri % 2 === 0 ? WHITE : "#FDFBF8", alignItems: "center" }}>
                  <select value={row.chapitre} onChange={e => updRow(row.id, "chapitre", e.target.value)}
                    style={{ fontSize: 11, border: "none", background: "transparent", color: MUTED, cursor: "pointer", width: "100%", fontFamily: "'DM Sans',sans-serif" }}>
                    {CHAPITRES.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                  <input className="tbl-inp" value={row.designation} onChange={e => updRow(row.id, "designation", e.target.value)} placeholder="Désignation…" />
                  <input type="number" className="tbl-inp" value={row.quantite} onChange={e => updRow(row.id, "quantite", e.target.value)} style={{ textAlign: "center" }} />
                  <select value={row.unite} onChange={e => updRow(row.id, "unite", e.target.value)} style={{ fontSize: 11, border: "none", background: "transparent", color: INK, cursor: "pointer", fontFamily: "'DM Sans',sans-serif" }}>
                    {UNITS.map(u => <option key={u} value={u}>{u}</option>)}
                  </select>
                  <input type="number" className="tbl-inp" value={row.puHt} onChange={e => updRow(row.id, "puHt", e.target.value)} style={{ textAlign: "right" }} />
                  <div style={{ textAlign: "right", fontSize: 12, fontWeight: 600 }}>{fmt((Number(row.quantite)||0)*(Number(row.puHt)||0))}</div>
                  <div className="no-print" style={{ display: "flex", gap: 2, justifyContent: "center" }}>
                    <button onClick={() => moveRow(row.id, "up")} style={{ background: "none", border: "none", cursor: "pointer", color: MUTED, fontSize: 12 }}>↑</button>
                    <button onClick={() => moveRow(row.id, "down")} style={{ background: "none", border: "none", cursor: "pointer", color: MUTED, fontSize: 12 }}>↓</button>
                    <button onClick={() => delRow(row.id)} style={{ background: "none", border: "none", cursor: "pointer", color: "#C0392B", fontSize: 14 }}>✕</button>
                  </div>
                </div>
              ))}
            </>
          )}

          {/* Totaux */}
          <div style={{ padding: "16px 24px", background: SOFT, borderTop: `2px solid ${BORDER}` }}>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div style={{ minWidth: 280 }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                  <span style={{ color: MUTED, fontSize: 13 }}>Total HT</span>
                  <span style={{ fontWeight: 600, fontSize: 13, color: INK }}>{fmt(totalHt)} MAD</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                  <span style={{ color: MUTED, fontSize: 13 }}>TVA 20 %</span>
                  <span style={{ fontSize: 13, color: MUTED }}>{fmt(tvaAmt)} MAD</span>
                </div>
                <div style={{ height: 1, background: BORDER, margin: "8px 0" }} />
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <span style={{ fontWeight: 800, fontSize: 15, color: INK }}>TOTAL TTC</span>
                  <span style={{ fontWeight: 800, fontSize: 16, color: GOLD }}>{fmt(totalTtc)} MAD</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </main>

      {/* ═══════ ZONE IMPRIMABLE (cachée à l'écran) ═══════ */}
      <div className="print-area" style={{ position: "fixed", top: 0, left: 0, width: "100%", padding: "30px 40px", background: WHITE, fontFamily: "'DM Sans',sans-serif", color: INK }}>

        {/* En-tête PDF */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 28, paddingBottom: 20, borderBottom: `2px solid ${GOLD}` }}>
          <div>
            {logoUrl && <img src={logoUrl} alt="Logo" style={{ height: 50, objectFit: "contain", marginBottom: 8 }} />}
            <div style={{ fontFamily: "'Playfair Display',serif", fontSize: 22, fontWeight: 700, color: INK }}>YOMA DESIGN SARL AU</div>
            <div style={{ fontSize: 11, color: MUTED, marginTop: 2 }}>Cabinet d'architecture intérieure et de décoration</div>
          </div>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 18, fontWeight: 800, color: GOLD, letterSpacing: 1 }}>DEVIS N° {devisNum}</div>
            <div style={{ fontSize: 12, color: MUTED, marginTop: 4 }}>
              Date : {new Date(devisDate).toLocaleDateString("fr-MA", { day: "2-digit", month: "long", year: "numeric" })}
            </div>
          </div>
        </div>

        {/* Infos client/projet */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24, marginBottom: 24, padding: "16px", background: SOFT, borderRadius: 8 }}>
          <div>
            <div style={{ fontSize: 9, fontWeight: 800, color: MUTED, letterSpacing: "0.1em", marginBottom: 6 }}>PROJET</div>
            <div style={{ fontWeight: 700, fontSize: 14 }}>{projName || "—"}</div>
            {clientAdresse && <div style={{ fontSize: 12, color: MUTED, marginTop: 2 }}>{clientAdresse}</div>}
          </div>
          <div>
            <div style={{ fontSize: 9, fontWeight: 800, color: MUTED, letterSpacing: "0.1em", marginBottom: 6 }}>CLIENT</div>
            <div style={{ fontWeight: 700, fontSize: 14 }}>{clientName || "—"}</div>
          </div>
        </div>

        {/* Tableau imprimable */}
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11, marginBottom: 20 }}>
          <thead>
            <tr style={{ background: INK, color: WHITE }}>
              <th style={{ padding: "8px 10px", textAlign: "left", fontWeight: 700 }}>Désignation</th>
              <th style={{ padding: "8px 10px", textAlign: "center", width: 70 }}>Qté</th>
              <th style={{ padding: "8px 10px", textAlign: "center", width: 50 }}>Unité</th>
              <th style={{ padding: "8px 10px", textAlign: "right", width: 110 }}>PU HT (MAD)</th>
              <th style={{ padding: "8px 10px", textAlign: "right", width: 120 }}>Total HT (MAD)</th>
            </tr>
          </thead>
          <tbody>
            {CHAPITRES.filter(ch => grouped[ch]?.length).map(ch => (
              <>
                <tr key={`hd-${ch}`} style={{ background: `${CHAPITRE_COLORS[ch] || "#4A3E35"}22` }}>
                  <td colSpan={4} style={{ padding: "6px 10px", fontWeight: 800, fontSize: 11, color: CHAPITRE_COLORS[ch] || INK }}>{ch}</td>
                  <td style={{ padding: "6px 10px", textAlign: "right", fontWeight: 700 }}>
                    {fmt(grouped[ch].reduce((s, r) => s + (Number(r.quantite)||0)*(Number(r.puHt)||0), 0))}
                  </td>
                </tr>
                {grouped[ch].map((row, i) => (
                  <tr key={row.id} style={{ background: i % 2 === 0 ? WHITE : "#FAFAF8", borderBottom: `1px solid ${BORDER}` }}>
                    <td style={{ padding: "5px 10px" }}>{row.designation}</td>
                    <td style={{ padding: "5px 10px", textAlign: "center" }}>{row.quantite}</td>
                    <td style={{ padding: "5px 10px", textAlign: "center" }}>{row.unite}</td>
                    <td style={{ padding: "5px 10px", textAlign: "right" }}>{fmt(Number(row.puHt))}</td>
                    <td style={{ padding: "5px 10px", textAlign: "right", fontWeight: 600 }}>
                      {fmt((Number(row.quantite)||0)*(Number(row.puHt)||0))}
                    </td>
                  </tr>
                ))}
              </>
            ))}
          </tbody>
        </table>

        {/* Totaux PDF */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 32 }}>
          <table style={{ minWidth: 280, fontSize: 12 }}>
            <tbody>
              <tr><td style={{ padding: "4px 12px", color: MUTED }}>Total HT</td><td style={{ textAlign: "right", fontWeight: 600 }}>{fmt(totalHt)} MAD</td></tr>
              <tr><td style={{ padding: "4px 12px", color: MUTED }}>TVA 20 %</td><td style={{ textAlign: "right" }}>{fmt(tvaAmt)} MAD</td></tr>
              <tr style={{ borderTop: `2px solid ${GOLD}` }}>
                <td style={{ padding: "8px 12px", fontWeight: 800, fontSize: 14 }}>TOTAL TTC</td>
                <td style={{ textAlign: "right", fontWeight: 800, fontSize: 15, color: GOLD }}>{fmt(totalTtc)} MAD</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Pied de page */}
        <div style={{ borderTop: `1px solid ${BORDER}`, paddingTop: 14, display: "flex", justifyContent: "space-between", fontSize: 10, color: MUTED }}>
          <div>YOMA DESIGN SARL AU — Mandataire exclusif de maîtrise d'œuvre</div>
          <div style={{ color: GOLD, fontWeight: 700 }}>yomadesign.ma</div>
        </div>
      </div>

    </div>
  );
}
